const PRINCIPLES = [
  {
    icon: 'ri-focus-3-line',
    title: '事实优先，分级核实',
    desc: '每条爆料附「已核实 / 待核实 / 持续更新」状态，缺证不妄下结论，宁缺毋滥。',
    accent: true,
  },
  {
    icon: 'ri-eye-off-line',
    title: '匿名保护第一',
    desc: '投稿人可完全匿名，可识别身份的信息一律打码，绝不公开投稿来源。',
    accent: false,
  },
  {
    icon: 'ri-community-line',
    title: '多方并陈，允许发声',
    desc: '涉重大爆料先给相关方回应机会，文中如实呈现「回应」或「未回应」状态。',
    accent: false,
  },
  {
    icon: 'ri-arrow-up-circle-line',
    title: '及时勘误，欢迎指正',
    desc: '有错必纠，设立勘误与投诉通道，经核实后公开修正或删除。',
    accent: false,
  },
];

export default function CommunityPrinciples() {
  return (
    <section id="principles" className="scroll-mt-28 bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-12 lg:items-center">
          <div className="lg:col-span-4">
            <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-primary-600">
              <i className="ri-secure-payment-line" aria-hidden="true"></i>
              社区原则
            </p>
            <h2 className="mt-2 font-display text-2xl font-bold text-foreground-950 md:text-3xl">
              爆料可以大胆，但必须负责
            </h2>
            <p className="mt-3 text-sm leading-7 text-foreground-600 md:text-[15px]">
              信息有价，真实更有价。51爆料建立在一套清晰的内容原则之上——保护爆料人、平衡各方声音、用机制代替情绪，让每一份「内部消息」都经得起推敲。
            </p>
            <span className="mt-5 inline-flex items-center gap-1.5 rounded-md bg-accent-500 px-4 py-2 text-xs font-semibold whitespace-nowrap text-background-50">
              <i className="ri-lock-2-fill" aria-hidden="true"></i>
              承诺：不公开任何投稿人真实身份
            </span>
          </div>

          <div className="grid gap-4 sm:grid-cols-2 lg:col-span-8">
            {PRINCIPLES.map((p, i) => (
              <div
                key={p.title}
                className={`relative overflow-hidden rounded-lg border p-6 ${
                  i === 0 ? 'border-primary-200 bg-primary-50/60' : 'border-background-200 bg-background-100/50'
                }`}
              >
                <span
                  className={`absolute right-4 top-4 font-display text-4xl font-black ${
                    p.accent ? 'text-primary-200' : 'text-background-300'
                  }`}
                >
                  {String(i + 1).padStart(2, '0')}
                </span>
                <span
                  className={`flex h-10 w-10 items-center justify-center rounded-md text-xl ${
                    p.accent ? 'bg-primary-600 text-background-50' : 'bg-accent-500 text-background-50'
                  }`}
                >
                  <i className={p.icon} aria-hidden="true"></i>
                </span>
                <h3 className="mt-4 font-display text-lg font-bold text-foreground-950">{p.title}</h3>
                <p className="mt-2 text-sm leading-7 text-foreground-700">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}